/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentTemplate } from './DocumentTemplate';
import {
    DocumentTemplateFromJSON,
    DocumentTemplateFromJSONTyped,
    DocumentTemplateToJSON,
} from './DocumentTemplate';

/**
 * 
 * @export
 * @interface GenerateTemplateFieldDescriptionsRequest
 */
export interface GenerateTemplateFieldDescriptionsRequest {
    /**
     * 
     * @type {DocumentTemplate}
     * @memberof GenerateTemplateFieldDescriptionsRequest
     */
    template: DocumentTemplate;
    /**
     * 
     * @type {string}
     * @memberof GenerateTemplateFieldDescriptionsRequest
     */
    filling_instructions?: string;
}

/**
 * Check if a given object implements the GenerateTemplateFieldDescriptionsRequest interface.
 */
export function instanceOfGenerateTemplateFieldDescriptionsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "template" in value;

    return isInstance;
}

export function GenerateTemplateFieldDescriptionsRequestFromJSON(json: any): GenerateTemplateFieldDescriptionsRequest {
    return GenerateTemplateFieldDescriptionsRequestFromJSONTyped(json, false);
}

export function GenerateTemplateFieldDescriptionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateTemplateFieldDescriptionsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'template': DocumentTemplateFromJSON(json['template']),
        'filling_instructions': !exists(json, 'filling_instructions') ? undefined : json['filling_instructions'],
    };
}

export function GenerateTemplateFieldDescriptionsRequestToJSON(value?: GenerateTemplateFieldDescriptionsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'template': DocumentTemplateToJSON(value.template),
        'filling_instructions': value.filling_instructions,
    };
}

